import React, { useState, useRef } from 'react';

const ScreenRecorder = () => {
  const [isRecording, setIsRecording] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const mediaRecorderRef = useRef(null);
  const streamRef = useRef(null);

  // Function to start screen recording
  const startRecording = async () => {
    try {
      // Get the screen and audio stream
      const screenStream = await navigator.mediaDevices.getDisplayMedia({
        video: true, 
        audio: true,
      });

      const micStream = await navigator.mediaDevices.getUserMedia({ audio: true });

      // Combine the screen and microphone streams
      const combinedStream = new MediaStream([
        ...screenStream.getTracks(),
        ...micStream.getTracks(),
      ]);

      // Create a MediaRecorder instance
      mediaRecorderRef.current = new MediaRecorder(combinedStream);
      const chunks = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        chunks.push(event.data);
      };

      mediaRecorderRef.current.onstop = () => {
        const blob = new Blob(chunks, { type: 'video/webm' });
        setVideoUrl(URL.createObjectURL(blob));
      };

      // Start recording
      mediaRecorderRef.current.start();
      setIsRecording(true);
      streamRef.current = combinedStream;
    } catch (err) {
      console.error('Error during recording:', err);
    }
  };

  // Function to stop screen recording
  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      streamRef.current.getTracks().forEach((track) => track.stop()); // Stop all tracks
    }
    setIsRecording(false);
  };

  return (
    <div>
      <h2>Screen Recorder with Microphone</h2>
      {isRecording ? (
        <button onClick={stopRecording}>Stop Recording</button>
      ) : (
        <button onClick={startRecording}>Start Recording</button>
      )}

      {videoUrl && (
        <div>
          <h3>Recorded Video</h3>
          <video controls src={videoUrl} width="600" />
        </div>
      )}
    </div>
  );
};

export default ScreenRecorder;
